import React from 'react'
import {useAuth} from '../context/AuthContext'
import {ROLES} from '../utils/roles'

const VIDEOS = [
    {
        id: 'intro',
        title: 'Introduktion til Sprogcenter.dk',
        description: 'Generel introduktion til systemet.',
        embedUrl: 'https://www.youtube.com/embed/0OgZ-Cjo-PE',
        roles: [ROLES.ADMIN, ROLES.SC_ADMIN, ROLES.CENSOR, ROLES.TEACHER],
    },
]

export default function HelpPage(){
    const {user} = useAuth()
    const visible = VIDEOS.filter(v => v.roles.includes(user?.role))

    return (
        <div className="panel-container">
            <div className="panel">
                <h1>Vejledninger</h1>

                {visible.length === 0 ? (
                    <p>Ingen vejledninger tilgængelige for din rolle endnu.</p>
                ) : (
                    visible.map(v => (
                        <div key={v.id} style={{marginBottom: '32px'}}>
                            <h3 style={{marginBottom: '4px'}}>{v.title}</h3>
                            {v.description && (
                                <p style={{marginTop: 0, color: '#666'}}>{v.description}</p>
                            )}
                            <div style={{position: 'relative', paddingBottom: '56.25%', height: 0, maxWidth: '720px'}}>
                                <iframe
                                    src={v.embedUrl}
                                    title={v.title}
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0}}
                                />
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    )
}
